function formatNumberTimeToTimeObj(numberTime) {
  if (numberTime === '' || numberTime === null) return ''
  if (numberTime < 0 || numberTime > 2400) return

  let hours = Math.floor(numberTime / 100)
  const isPm = hours >= 12
  hours = hours % 12 || 12

  let minutes = numberTime % 100
  minutes = minutes < 10 ? `0${minutes}` : minutes

  return { hours, minutes, isPm }
}

function formatNumberTimeToLocaleString(numberTime) {
  const { hours, minutes, isPm } = formatNumberTimeToTimeObj(numberTime)

  return [String(hours), minutes].join(':') + (isPm ? ' PM' : ' AM')
}

export { formatNumberTimeToTimeObj, formatNumberTimeToLocaleString }
